import { appRouting } from 'v5/core/routing/appRouting';
import { WithServices } from 'v5/platform/ts/services';
import { WithUserFlowService } from 'v5/services/front/UserFlowService/UserFlowService';
import { WithAppScopeService } from 'v5/services/internal/AppScopeService/AppScopeService';
import { WithNavigationService } from 'v5/services/internal/NavigationService/NavigationService';

/**
 * Opens the create-workspace dialog; a created workspace opens on its
 * dashboard, not on its resource list, like `/app` and `/app/:id` do
 * (PrivateRoute).
 */
export function useCreateEnterpriseWorkspace(
  {
    services
  }: WithServices<
    [WithAppScopeService, WithUserFlowService, WithNavigationService<{}>]
  >,
  organizationId: string
) {
  const slugAppScope = services.appScopeService.useSlugAppScope();

  return () => {
    services.userFlowService.openCreateEnterpriseWorkspaceDialog(
      organizationId,
      {
        appScope: slugAppScope,
        onCreated: workspace => {
          services.navigationService.navigate(
            appRouting.org(organizationId).workspace(workspace.slug).dashboard()
          );
        }
      }
    );
  };
}
